<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <button
      :id="id"
      :type="type"
      :disabled="disabled"
      class="ui-button"
      :class="[variant, size, $attrs.class]"
      :aria-describedby="`${id}-help`"
      :aria-label="icon ? `${label} with ${getIconName(icon)} icon` : label"
      @click="$emit('click', $event)"
      v-bind="$attrs"
    >
      <i v-if="icon" class="button-icon" :class="icon"></i>
      <slot>{{ label }}</slot>
    </button>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "button",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: "primary",
      validator: (value) =>
        ["primary", "secondary", "danger", "buttongroup"].includes(value),
    },
    size: {
      type: String,
      default: "large",
      validator: (value) => ["small", "medium", "large"].includes(value),
    },
    icon: {
      type: String,
      default: null,
    },
  },
  emits: ["click"],
  methods: {
    getIconName(iconClasses) {
      if (!iconClasses) return "unknown";
      // Split the classes (e.g., "fa fa-plus") and get the last class
      const classes = iconClasses.split(/\s+/);
      // Find the class that starts with "fa-" (specific to Font Awesome icons)
      const iconClass = classes.find((cls) => cls.startsWith("fa-"));
      if (!iconClass) return "unknown";
      // Remove "fa-" prefix and return the icon name (e.g., "plus", "trash", "edit")
      return iconClass.replace(/^fa-/, "").replace(/-/g, " ");
    },
  },
};
</script>

<style lang="scss" scoped>

.ui-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: auto;
  padding: 8px 13px;
  border-radius: 4px;
  font-family: "Voyado Text";
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s, border-color 0.2s, opacity 0.2s;
  // line-height: 1.5;
  gap: 0.5rem;
}

.ui-button-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.ui-button.small {
  height: 24px;
  font-size: 12.64px;
  // padding: 4px 8px;
}

.ui-button.medium {
  height: 32px;
  font-size: 13px;
  // padding: 6px 12px;
}

.ui-button.large {
  height: 40px;
  font-size: 14.22px;
  // padding: 8px 16px;
}

.ui-button.primary {
  background: #2d6e6d;
  border: none;
  color: #ffffff;
}

.ui-button.primary:hover:not(:disabled) {
  background-color: #388988;
  border-color: #388988;
}

.ui-button.secondary {
  background-color: #ffffff;
  border: 2px solid #e0e9e8;
  color: #2d6e6d;
}

.ui-button.secondary:hover:not(:disabled) {
  background-color: #e0e9e8;
  border-color: #e0e9e8;
  color: #2d6e6d;
}

.ui-button.danger {
  background-color: #bf1100;
  color: #ffffff;
  border: 2px solid #bf1100;
}

.ui-button.buttongroup {
  background-color: #ffffff;
  color: #000;
  border-radius: 0px;
  height: calc(100% - 0.01px);
}

.ui-button.buttongroup:hover:not(:disabled) {
  background-color: #256b64;
  border: 2px solid #256b64;
  color: #ffffff;
}

.ui-button:disabled {
  background-color: #e9ecef;
  color: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

.ui-button.p-invalid {
  border-color: #dc3545;
  background-color: #dc3545;
}

.ui-button.p-invalid:hover:not(:disabled) {
  background-color: #c82333;
  border-color: #c82333;
}

.p-error {
  color: #dc3545;
  font-size: 0.875rem;
  margin-top: 0.25rem;
  display: block;
}
</style>